import React from 'react';
import { Box, Chip, Stack, LinearProgress, Typography } from '@mui/material';
import ApprovalGateCard from './ApprovalGateCard';

export interface GateWithStatus {
  id: string;
  name: string;
  completed: boolean;
  completedDate?: string;
  dueDate?: string;
  required: string;
  reviewers: string;
  completedBy?: {
    name: string;
    email: string;
  };
  notes?: string;
  sort_order: number;
}

interface ApprovalGatesSectionProps {
  gates: GateWithStatus[];
  onGateToggle: (gateId: string, currentStatus: boolean) => void;
  onRefresh: () => Promise<void>;
}

const ApprovalGatesSection: React.FC<ApprovalGatesSectionProps> = ({
  gates,
  onGateToggle,
  onRefresh,
}) => {
  const completedCount = gates.filter((g) => g.completed).length;
  const progressPercentage =
    gates.length > 0 ? (completedCount / gates.length) * 100 : 0;

  const handleCheckboxChange = (
    gateId: string,
    currentStatus: boolean
  ): void => {
    onGateToggle(gateId, currentStatus);
  };

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
        flexWrap="wrap"
        gap={1}
      >
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Typography
            variant="h3"
            sx={{ fontSize: '1.25rem', fontWeight: 600 }}
          >
            Approval Gates
          </Typography>
          <Chip
            label={`${completedCount}/${gates.length} Complete`}
            size="small"
          />
        </Stack>

        <LinearProgress
          variant="determinate"
          value={progressPercentage}
          sx={{
            width: 120,
            height: 6,
            borderRadius: 5,
            backgroundColor: '#D1F27A',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#06362B',
            },
          }}
        />
      </Stack>

      {gates.map((gate, index) => (
        <ApprovalGateCard
          key={gate.id}
          gate={gate}
          index={index + 1}
          onCheckboxChange={handleCheckboxChange}
          onRefresh={onRefresh}
        />
      ))}

      {gates.length === 0 && (
        <Box className="empty-content">
          <Typography> No approval gates found</Typography>
        </Box>
      )}
    </Box>
  );
};

export default ApprovalGatesSection;
